import C from '../constants';

// Only for placement level, editingImage will have Type field
export const getEditingMediaProps = ({
  editingImage: model,
  isMultimediaAd,
  imageOption = C.defaultImageOption,
  isCombinedMsanAndMmaAspectRatios,
  isMMAV2Enabled = false,
  isLinkedInAd = false,
  isUnifiedAppCampaignWindowsStore = false,
  selectedImageType,
  isPMaxAspectRatiosV2Enabled = false,
}) => {
  const editingMedia = model || {};
  const imageType = editingMedia.Type;
  const orginalAsset = imageType ? editingMedia.BaseImage : editingMedia;

  const { EffectSettings, CropSettings, BaseImage } = editingMedia;
  const minCropSize = C.getMinimumSizeForImage(
    selectedImageType || imageType,
    isMultimediaAd,
    imageOption,
    isCombinedMsanAndMmaAspectRatios,
    isMMAV2Enabled,
    false, /* isDisplayAds */
    false, /* isPortraitImage */
    false, /* isBoost200x100ImageEnabled */
    false, /* isBoostNewAspectRatioSupportEnabled */
    false, /* isStoreAppProng */
    false, /* isStoreAppSpotLight */
    false, /* isStoreAppTransparentLogo */
    isLinkedInAd,
    isUnifiedAppCampaignWindowsStore,
    isPMaxAspectRatiosV2Enabled
  );

  return {
    // settings such as crop and effect are actually applied to original image
    // so here except Type, others in baseImage should come from original image.
    baseImage: {
      Type: editingMedia.Type,
      Src: orginalAsset.Src,
      Width: orginalAsset.Width,
      Height: orginalAsset.Height,
      AltText: editingMedia.AltText,
    },
    effectSettings: EffectSettings,
    cropSettings: CropSettings,
    minCropSize,
    maxCropBox: imageType ? BaseImage.CropSettings : null,
  };
};
